// 新广告系统
import { request } from '../request.js';
import config from '../../common/config/config';
import { resolveApi } from 'root/common/util/requestHelper';

// 获取广告数据
export const getAdvertise = (positions = '') => {
    return request({
        url: config.api.newAdvertise,
        method: 'get',
        params: { positions },
        isNeedToken: false,
    });
};

/**
 * 新广告位
 * @param {*} data
 * @returns
 */
export function getNewAdvertise(data) {
    return request({
        url: config.api.newAdvertise,
        params: data,
        isNeedToken: false,
    });
}

/**
 * 处理新广告系统数据
 * @param {*} data
 * @param {*} data.positions 广告位唯一标识
 * @returns
 */
export const getAdvertiseList = async data => {
    const res = await resolveApi(getNewAdvertise(data), { code: 0 });
    const positions = res.positions || {};
    // 展开每一个运营位的数据
    Object.keys(positions).forEach(position => {
        const advList = positions[position] || [];
        positions[position] = advList.map(item => ({
            id: item.id,
            name: item.name,
            endTime: item.endTime,
            childNode: item.childNode,
            hotspotList: item.hotspotList,
            ...(item.contentObj || {}),
        }));
    });
    return positions;
};

//洗数据（肯德基banner）
export const getAdvertiseBySwiperBanner = async (data, moduleTag) => {
    let dataEntry = {};
    const positions = data.positions ? data.positions + '' : '';
    const advList = await getAdvertiseList(data);
    const formatData = position => {
        const bannerList = advList[position];
        return bannerList.map((item, index) => ({
            businessId: item.id,
            name: item.name,
            page: document.title,
            position: String(index + 1),
            bannerImg: item.img,
            jumpObject: item.url,
            jumpType: 3,
            moduleTag,
        }));
    };
    if (positions) {
        if (positions.indexOf(',') > -1) {
            const positionsArr = positions.split(',').filter(x => x);
            positionsArr.forEach(position => {
                dataEntry[position] = formatData(position);
            });
        } else {
            dataEntry[positions] = formatData(positions);
        }
    }
    return dataEntry;
};

//洗数据（超市）
export const getAdvertiseBySuperMarket = async data => {
    //新广告位超市 洗数据
    const res = await resolveApi(getNewAdvertise(data), { code: 0 });
    const positions = res.positions || {};
    // 展开每一个运营位的数据
    Object.keys(positions).forEach(position => {
        const advList = positions[position] || [];
        const entryList = advList.map(item => {
            return {
                id: item.id,
                name: item.name,
                endTime: item.endTime,
                childNode: item.childNode,
                hotspotList: item.hotspotList,
                ...(item?.contentObj || {}),
                businessId: item.id,
                isPrivate: 0,
                extra: null,
                start_time: '',
                end_time: '',
            };
        });
        positions[position] = entryList;
    });
    return positions;
};

//洗数据（超市banner）
export const getAdvertiseBannerBySuperMarket = async data => {
    const positions = data?.positions ? data.positions + '' : '';
    const advList = await getAdvertiseList(data);
    const bannerList = advList[positions] || [];
    return bannerList.map(item => ({
        businessId: item.id,
        name: item.name,
        ...item,
    }));
};
